<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-09 15:37:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/category/components/CategoryLeft/index.vue
-->
<template>
  <div class="left_menu">
    <div
      v-for="(item, index) in categoriesList"
      :key="index"
      :class="{ list_s: index === switchIndex }"
      class="item_list clearfix"
    >
      <!-- <div
        :class="{ item_line_s: index === switchIndex }"
        class="left item_line"
      /> -->
      <div
        @click="switchTab(index)"
        :class="{ item_s: index === switchIndex }"
        class="left item_uns text_left"
      >
        <div
          :class="{ left_line_col: index === switchIndex }"
          class="item_left_line"
        ></div>
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      switchIndex: 0
    };
  },
  computed: {
    categoriesList() {
      return this.$store.getters.categoriesList;
    }
  },
  methods: {
    switchTab(index) {
      this.switchIndex = index;
      this.$emit("switchTab", index);
    }
  }
};
</script>

<style scoped>
.left_menu {
  width: 80px;
}
.item_list {
  width: 80px;
  font-size: 12px;
  color: #000;
  font-weight: 400;
  padding: 10px 10px 10px 0;
  box-sizing: border-box;
}
.item_s {
  font-weight: 600;
  color: #bf9264;
  background: #fff;
  /* padding-left: 12px; */
  /* border-left: 4px solid #bf9264 !important; */
}
.list_s {
  background: #fff;
}
.item_uns {
  /* padding-left: 12px; */
  /* border-left: 4px solid #f6f7f8; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.item_left_line {
  width: 4px;
  height: 24px;
  background: #f6f7f8;
  border-radius: 2px;
  margin-right: 12px;
}
.left_line_col {
  background: #bf9264;
}
.item_line {
  background: #fff;
  margin-right: 12px;
}
.item_line_s {
  background: #bf9264;
}
</style>
